import { makeApiRequest } from '@/src/lib/api-request'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { User } from '@/src/types/user'
import { useMutation } from '@tanstack/react-query'

export const useAppleLoginMutation = () => {
  const { setRefreshToken, setUser } = useUser()
  const { setToken } = useToken()
  return useMutation({
    mutationKey: ['user', 'apple-login'],
    mutationFn: async (params: { id_token: string }) => {
      const response = await makeApiRequest({
        isAuthenticated: false,
        fallbackError: 'Error while logging in with Apple',
        method: 'POST',
        url: '/AppleLoginAPI/signinApple',
        data: { appleAuth: params.id_token },
        isV3Api : true,
      })

      setToken(response.token)
      setRefreshToken(response.refresh_token)
      setUser(response.response)

      return response.response as User
    },
  })
}
